import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import './AdminNavDrawer.scss';

import SearchInput from '../SearchInput/SearchInput';
import AdminNavMenuItem from './AdminNavMenuItem';
import { searchNavItems, sortNavItemsAlphabetically, getPinnedAndRecentItems } from '../../helpers/nav_helpers';

const AdminNavDrawer = ({ onClose, items, pinnedKeys, recentKeys, activeKey, onTogglePin, onRestoreClassicMenu }) => {
  const [query, setQuery] = useState('');
  const pinnedSet = new Set(pinnedKeys);

  // While searching, collapse to a single flat alphabetical result list.
  const searchResults = query.trim() ? sortNavItemsAlphabetically(searchNavItems(items, query)) : null;

  const { pinnedItems, recentItems } = getPinnedAndRecentItems(pinnedKeys, recentKeys, items);
  const allItems = sortNavItemsAlphabetically(items);

  const sections = [
    {
      key: 'pinned',
      title: 'Pinned',
      items: pinnedItems,
      emptyText: 'Pin sections with the thumbtack to keep them in the top bar.'
    },
    { key: 'recent', title: 'Most Recent', items: recentItems },
    { key: 'all', title: 'All Sections', items: allItems }
  ];

  const renderItem = item => (
    <AdminNavMenuItem
      key={item.key}
      item={item}
      isActive={item.key === activeKey}
      isPinned={pinnedSet.has(item.key)}
      onTogglePin={onTogglePin}
    />
  );

  return (
    <div className='admin-nav-drawer-outer'>
      <div className='drawer-backdrop' onClick={onClose} />
      <div className='drawer-panel' role='dialog' aria-modal='true' aria-labelledby='admin-nav-drawer-title'>
        <div className='drawer-header'>
          <h2 className='drawer-title' id='admin-nav-drawer-title'>Menu</h2>
          <div className='drawer-header-actions'>
            <button className='restore-old-menu' onClick={onRestoreClassicMenu} type='button'>
              Restore old menu
            </button>
            <button className='drawer-close' onClick={onClose} type='button' aria-label='Close menu'>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>

        <div className='drawer-search'>
          <SearchInput
            value={query}
            onChange={e => setQuery(e.target.value)}
            onClear={() => setQuery('')}
            placeholder='Search the menu...'
            showSearchIcon
            autoFocus
          />
        </div>

        <div className='drawer-sections'>
          {searchResults ? (
            <div className='drawer-section'>
              <div className='section-title'>{searchResults.length ? 'Results' : 'No matches'}</div>
              {searchResults.map(renderItem)}
            </div>
          ) : (
            sections.map(section => {
              if (!section.items.length && !section.emptyText) return null;
              return (
                <div key={section.key} className='drawer-section'>
                  <div className='section-title'>{section.title}</div>
                  {section.items.length ? section.items.map(renderItem) : <div className='section-empty'>{section.emptyText}</div>}
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

AdminNavDrawer.propTypes = {
  onClose: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  pinnedKeys: PropTypes.array.isRequired,
  recentKeys: PropTypes.array.isRequired,
  activeKey: PropTypes.string,
  onTogglePin: PropTypes.func.isRequired,
  onRestoreClassicMenu: PropTypes.func.isRequired
};

export default AdminNavDrawer;
